module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG1005-a28562f9d7425b7ba1cf4cc478af8fbe.png";